import React from 'react';
import {baseUrl} from '../url';
import moment from 'moment';
import { Redirect } from 'react-router-dom';
import inputLoader from '../../assets/input-loader.svg';
import inputLoaderWhite from '../../assets/input-loader-white.svg';

class EditProfile extends React.Component{
    constructor(){
        super()
        this.state={
            details: {},
            states: [],
            lgas: [],
            type: '',
            prefix: '',
            first_name: '',
            last_name: '',
            marital_status: '',
            alias: '',
            sex: '',
            dob: '',
            address: '',
            lga: '',
            phone_no: '',
            occupation: '',
            height: '',
            referral: '',
            no_of_children: '',
            sod: '',
            history_of_intake: '',
            treatment_time: '',
            treatment_phase: '',
            state: '',
            lgaResponse: true,
            aliasResponse: true,
            phone_noResponse: true,
            saveResponse: true,

            page_error: '',
            lgaError: '',

            redirect: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkUnique = this.checkUnique.bind(this);
        this.handleLgas =  this.handleLgas.bind(this);
    }
    componentDidMount(){
        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id'),
            user_t = localStorage.getItem('user_type');
            // user_type = JSON.parse(user_t);
        fetch(`${baseUrl}/admin/users/${user_t}/${user_id}`,{
            method: 'GET',
            headers:{
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then(responseJson => {
            let bio = responseJson.data.bio,
                record = responseJson.data.hospital_record;
            this.setState({
                details: responseJson.data,
                type: user_t,
                prefix: bio.prefix,
                first_name: bio.names.first,
                last_name: bio.names.last,
                marital_status: bio.marital_status,
                alias: bio.alias,
                sex: bio.sex,
                dob: bio.dob,
                address: bio.address,
                occupation: bio.occupation,
                lga: bio.lga,
                state: bio.state,
                phone_no: bio.phone_no,
                height: record.height,
                referral: record.referral,
                no_of_children: record.no_of_children,
                sod: record.site_of_disease,
                history_of_intake: record.history_of_intake,
                treatment_time: record.treatment_time,
                treatment_phase: record.treatment_phase
            })
        })

        let states = []
        fetch(`http://locationsng-api.herokuapp.com/api/v1/states`,{
            method: 'GET',
        })
        .then((response) => response.json())
        .then((responseJson) => {
            states = responseJson.map((state) => {
                return state.name
            });
            this.setState({
                states,
            })
        })
    }


    handleChange(e){
        if(e.target.name === 'caregiver_name'){
            this.state.caregivers.forEach(caregiver => {
                if(caregiver.name === e.target.value){
                    this.setState({
                        caregiver_id: caregiver.id
                    })
                }
            })
        }
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: '',
            page_error: ''
        })
        if(e.target.name === 'phone_no'){
            if(e.target.value.length >= 8){
                if(!/(0[7-9][01])\d{8}/.test(e.target.value)){
                    this.setState({
                        phone_noError: 'Please enter a valid phone number'
                    })
                }
            }
        }
        if(e.target.name === 'weight'){
            if(e.target.value < 30 || e.target.value > 70){
                this.setState({
                    weightError: 'Weight should be between 30 & 70'
                })
            }
        }
        if(e.target.name === 'dob'){
            let dob = moment(e.target.value);
            let currDate = moment();
            let diff = currDate.diff(dob, 'years');

            if(diff < 15){
                this.setState({
                    dobError: "Age shouldn't be less than 15"
                })
            }
        }
        if(e.target.name === 'state'){
            this.setState({
                lga: ''
            })
        }
        if((e.target.name === 'alias' || e.target.name === 'treatment_no' || e.target.name === 'phone_no') && e.target.value.length > 0){
            this.checkUnique(e.target.name, e.target.value);
        }
    }

    checkUnique(item, value){
        if(item === 'alias'){
            this.setState({
                aliasResponse: false
            })
        }
        if(item === 'treatment_no'){
            this.setState({
                treatmentResponse: false
            })
        }
        if(item === 'phone_no'){
            this.setState({
                phone_noResponse: false
            })
        }
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/unique?item=${item}&value=${value}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then((response) => {
            response.json()
            if(item === 'alias'){
                this.setState({
                    aliasResponse: true
                })
            }
            if(item === 'treatment_no'){
                this.setState({
                    treatmentResponse: true
                })
            }
            if(item === 'phone_no'){
                this.setState({
                    phone_noResponse: true
                })
            }
            if(response.status === 409){
                if(item === 'alias'){
                    this.setState({
                        aliasError: 'Alias is already in use.'
                    })
                    if(value === this.state.details.bio.alias){
                        this.setState({
                            aliasError: ''
                        })
                    }
                }
                else if(item === 'phone_no'){
                    this.setState({
                        phone_noError: 'Phone number is already in use.'
                    })
                    if(value === this.state.details.bio.phone_no){
                        this.setState({
                            phone_noError: ''
                        })
                    }
                }
                else if(item === 'treatment_no'){
                    this.setState({
                        treatment_noError: 'Treatment number already exists.',
                        treatmentResponse: true
                    })
                }
            }
        })
    }

    handleLgas(){
        this.setState({
            lgaResponse: false
        })
        fetch(`http://locationsng-api.herokuapp.com/api/v1/states/${this.state.state}/lgas`,{
            method: 'GET',
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({
                lgas: responseJson,
                lgaResponse: true
            })
        })
    }

    handleSubmit(e){
        e.preventDefault();
        const {
            prefix,
            first_name,
            last_name,
            marital_status,
            alias,
            sex,
            dob,
            address,
            occupation,
            lga,
            state,
            phone_no,
            height,
            referral,
            no_of_children,
            sod,
            history_of_intake,
            treatment_time,
            treatment_phase,

            phone_noError,
            aliasError,
            dobError,
            lgaError
        } = this.state;

        if(!prefix){
            this.setState({
                prefixError: 'This field should not be empty'
            })
        }
        if(!first_name){
            this.setState({
                first_nameError: 'This field should not be empty'
            })
        }
        if(!last_name){
            this.setState({
                last_nameError: 'This field should not be empty'
            })
        }
        if(!marital_status){
            this.setState({
                marital_statusError: 'This field should not be empty'
            })
        }
        if(!alias){
            this.setState({
                aliasError: 'This field should not be empty'
            })
        }
        if(!sex){
            this.setState({
                sexError: 'This field should not be empty'
            })
        }
        if(!dob){
            this.setState({
                dobError: 'This field should not be empty'
            })
        }
        if(!address){
            this.setState({
                addressError: 'This field should not be empty'
            })
        }
        if(!occupation){
            this.setState({
                occupationError: 'This field should not be empty'
            })
        }
        if(!lga){
            this.setState({
                lgaError: 'This field should not be empty'
            })
        }
        if(!state){
            this.setState({
                stateError: 'This field should not be empty'
            })
        }
        if(!phone_no){
            this.setState({
                phone_noError: 'This field should not be empty'
            })
        }
        if(!height){
            this.setState({
                heightError: 'This field should not be empty'
            })
        }
        if(!referral){
            this.setState({
                referralError: 'This field should not be empty'
            })
        }
        if(no_of_children === null){
            this.setState({
                no_of_childrenError: 'This field should not be empty'
            })
        }
        if(!sod){
            this.setState({
                sodError: 'This field should not be empty'
            })
        }
        if(history_of_intake  === null){
            this.setState({
                history_of_intakeError: 'This field should not be empty'
            })
        }
        if(!treatment_time){
            this.setState({
                treatment_timeError: 'This field should not be empty'
            })
        }
        if(!treatment_phase){
            this.setState({
                treatment_phaseError: 'This field should not be empty'
            })
        }
        if(prefix && first_name && last_name && marital_status && alias && sex && dob && address && occupation && lga && state && phone_no && height && referral && no_of_children !== null && sod && history_of_intake !== null && treatment_time && treatment_phase && !phone_noError && !aliasError && !dobError && !lgaError){
        
            this.setState({
                saveResponse: false
            })

            let token = localStorage.getItem('access_token'),
                user_id = localStorage.getItem('user_id');

            let dateObj = moment(dob, 'YYYY-MM-DD'),
                date = dateObj.format('DD-MM-YYYY');

            let timeObj = moment(treatment_time, 'HH:mm'),
                time = timeObj.format('hh:mm A');

            let retries = 0;

            fetch(`${baseUrl}/admin/users/update/${user_id}`,{
                method: 'PUT',
                headers:{
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    "type": this.state.type,
                    "prefix": this.state.prefix,
                    "first_name": this.state.first_name,
                    "last_name": this.state.last_name,
                    "alias": this.state.alias,
                    "phone_no": this.state.phone_no,
                    "sex": this.state.sex,
                    "dob": date,
                    "marital_status": this.state.marital_status,
                    "address": this.state.address,
                    "lga": this.state.lga,
                    "state": this.state.state,
                    "height": this.state.height,
                    "occupation": this.state.occupation,
                    "no_of_children": this.state.no_of_children,
                    "history_of_intake": this.state.history_of_intake,
                    "referral": this.state.referral,
                    "sod": this.state.sod,
                    "treatment_phase": this.state.treatment_phase,
                    "treatment_time": time,
                })
            })
            .then((response) => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then((responseJson) => {
                if(responseJson.hasOwnProperty('message')){
                    if(responseJson.message === 'User updated.'){
                        this.setState({
                            redirect: true,
                            saveResponse: true
                        })
                    }
                }
            })
            .catch((error)=>{
                if (error === 401 && retries < 1){
                    localStorage.getItem('access_token')
                    .then(value => {
                        fetch(`${baseUrl}/token/refresh'`,{
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': value
                            }
                        }).then(response => {
                            retries += 1;
                            if(response.status === 200){
                                localStorage.setItem('access_token', response.headers.get('Authorization'));
                                this.handleSubmit();
                            }
                            else{
                                alert('something went wrong please try again later');
                            }
                        })
                    })
                }
                else{
                    alert('something went wrong please try again later');
                }
            })
        }else{
            this.setState({
                page_error: 'There are errors on this page'
            })
        }
    }

    render(){
        let { details, states, lgas, redirect, lgaResponse, phone_noResponse, aliasResponse } = this.state;
        
        let getInitials = (value) =>{
            let matches = value.match(/\b(\w)/g);
            let nameBadge = matches.join('');
            return nameBadge;
        }

        let bio = details.bio;

        let pBadge;
        if(bio){
            pBadge = getInitials(bio.name).toUpperCase();
        }

        let stateOption = states.map((state, index) => 
            <option key={index}>{state === 'Federal Capital Territory'?'Abuja':state}</option>
        )
        let lgaOption
        if(lgas.length > 0){
            lgaOption = lgas.map((lga, index) => 
                <option key={index}>{lga !== this.state.lga && lga}</option>
            )
        }

        if(redirect){
            return <Redirect exact to='/patient'/>
        }
        return(
            <div className="edit-patient-profile">
                <div className="container-fluid">
                <form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-sm-9">
                            <div className="edit-content">
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="name-badge">
                                            {pBadge}
                                        </div>
                                    </div>
                                    <div className="col-sm-10">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Title
                                                    <select 
                                                        name="prefix" 
                                                        className={this.state.prefixError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.prefix}>
                                                        <option value="dr">Dr</option>
                                                        <option value="mr">Mr</option>
                                                        <option value="mrs">Mrs</option>
                                                        <option value="ms">Ms</option>
                                                    </select>
                                                    <span className="error-text">{this.state.prefixError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    First Name
                                                    <input 
                                                        type="text" 
                                                        name="first_name" 
                                                        className={this.state.first_nameError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.first_name}/>
                                                    <span className="error-text">{this.state.first_nameError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Last Name
                                                    <input 
                                                        type="text" 
                                                        name="last_name" 
                                                        className={this.state.last_nameError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.last_name}/>
                                                    <span className="error-text">{this.state.last_nameError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    Alias
                                                    <input 
                                                        type="text" 
                                                        name="alias" 
                                                        className={this.state.aliasError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.alias}/>
                                                    {!aliasResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                                    <span className="error-text">{this.state.aliasError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Sex
                                                    <select 
                                                        name="sex" 
                                                        className={this.state.sexError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.sex}>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </select>
                                                    <span className="error-text">{this.state.sexError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    Date of birth
                                                    <input 
                                                        type="date" 
                                                        name="dob" 
                                                        className={this.state.dobError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.dob}/>
                                                    <span className="error-text">{this.state.dobError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Height
                                                    <input 
                                                        type="number" 
                                                        name="height" 
                                                        className={this.state.heightError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.height}/>
                                                    <span>Metres</span>
                                                    <span className="error-text">{this.state.heightError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    Occupation
                                                    <input 
                                                        type="text" 
                                                        name="occupation" 
                                                        className={this.state.occupationError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.occupation}/>
                                                    <span className="error-text">{this.state.occupationError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Phone Number
                                                    <input 
                                                        type="text" 
                                                        name="phone_no" 
                                                        className={this.state.phone_noError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.phone_no}/>
                                                    {!phone_noResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                                    <span className="error-text">{this.state.phone_noError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    Address
                                                    <input 
                                                        type="text" 
                                                        name="address" 
                                                        className={this.state.addressError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.address}/>
                                                    <span className="error-text">{this.state.addressError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    State
                                                    <select 
                                                        name="state" 
                                                        className={this.state.stateError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        onBlur={() => this.handleLgas()}
                                                        value={this.state.state}>
                                                        {stateOption}
                                                    </select>
                                                    <span className="error-text">{this.state.stateError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    LGA
                                                    <select 
                                                        name="lga" 
                                                        className={this.state.lgaError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        onClick={this.handleLgas}
                                                        value={this.state.lga}>
                                                        <option value={this.state.lga}>{this.state.lga === ''? 'select...':this.state.lga}</option>
                                                        {lgaOption}
                                                    </select>
                                                    {!lgaResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                                    <span className="error-text">{this.state.lgaError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Marital Status
                                                    <select 
                                                        name="marital_status" 
                                                        className={this.state.marital_statusError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.marital_status}>
                                                        <option value="single">Single</option>
                                                        <option value="married">Married</option>
                                                        <option value="seperated">Separated</option>
                                                        <option value="divorced">Divorced</option>
                                                        <option value="widowed">Widowed</option>
                                                    </select>
                                                    <span className="error-text">{this.state.marital_statusError}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-9">
                            <div className="edit-content">
                                <div className="row">
                                    <div className="col-sm-10 offset-sm-2">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Who referred patient
                                                    <select 
                                                        name="referral" 
                                                        className={this.state.referralError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.referral}>
                                                        <option value="ART facility">ART facility</option>
                                                        <option value="DOTS facility">DOTS facility</option>
                                                        <option value="TB patient">TB patient</option>
                                                        <option value="OPD">OPD</option>
                                                        <option value="CV">CV</option>
                                                        <option value="TS">TS</option>
                                                        <option value="CTW">CTW</option>
                                                        <option value="PPM Scheme 1 facility">PPM Scheme 1 facility</option>
                                                        <option value="Others">Others</option>
                                                    </select>
                                                    <span className="error-text">{this.state.referralError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    No of Children less than 6 years
                                                    <input 
                                                        type="number" 
                                                        name="no_of_children" 
                                                        className={this.state.no_of_childrenError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.no_of_children}/>
                                                    <span className="error-text">{this.state.no_of_childrenError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Site of disease
                                                    <select 
                                                        name="sod" 
                                                        className={this.state.sodError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.sod}>
                                                        <option value="Pulmonary">Pulmonary (P)</option>
                                                        <option value="Extrapulmonary">Extrapulmonary (EP)</option>
                                                    </select>
                                                    <span className="error-text">{this.state.sodError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    History of intake of Tuberculosis drugs
                                                    <input type="number" 
                                                        name="history_of_intake" 
                                                        className={this.state.history_of_intakeError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.history_of_intake}/>
                                                    <span>Weeks</span>
                                                    <span className="error-text">{this.state.history_of_intakeError}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label>
                                                    Treatment Phase
                                                    <select 
                                                        name="treatment_phase" 
                                                        className={this.state.treatment_phaseError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.treatment_phase}>
                                                        <option value="intensive">Intensive</option>
                                                        <option value="continuation">Continuation</option>
                                                    </select>
                                                    <span className="error-text">{this.state.treatment_phaseError}</span>
                                                </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <label>
                                                    Treatment Time
                                                    <input 
                                                        type="time" 
                                                        name="treatment_time" 
                                                        className={this.state.treatment_timeError && 'error-input'} 
                                                        onChange={this.handleChange}
                                                        value={this.state.treatment_time}/>
                                                    <span className="error-text">{this.state.treatment_timeError}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-9">
                            <div className="button-div">
                                <div className="error-cont"><span className="prev-error-text">{this.state.page_error}</span></div>
                                <button className="button">Cancel</button>
                                <button type="submit">Save Changes {!this.state.saveResponse && <img src={inputLoaderWhite} alt='' className='input-loader'/>}</button>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default EditProfile;


// WEBPACK FOOTER //
// ./src/components/patientProfile/EditProfile.js